import { css, html, LitElement } from 'lit-element';
import i18n from '@giswebgroup/ki-wcp-base/src/decorators/i18n';
import computed from '@giswebgroup/ki-wcp-base/src/decorators/computed';
import query from '@giswebgroup/ki-wcp-base/src/decorators/query';
import autoRun from '@giswebgroup/ki-wcp-base/src/decorators/autoRun';
import LoaderMixin from '@giswebgroup/ki-wcp-base/src/common/LoaderMixin';
import nls from '../../locales/index.nls';

export default
@i18n(nls)
class KiStationReport extends LoaderMixin(LitElement) {
  // language=CSS
  static styles = css`
    .station-report {
      height: 100%;
      width: 100%;
    }
    #close-btn {
      position: absolute;
      z-index: 11;
      top: 50px;
      right: 30px;
    }
  `;

  @computed('path')
  get _srcPath() {
    // http://vm-webdev-1.kisters.de/reports/stadescr?station_path=DCENN/PZ159
    return new URL(`${this.reportSrv}/stadescr?station_path=${this.path}`, window.location.origin).href;
  }

  @query('#iframeNode')
  _iframeNode;

  static get properties() {
    return {
      reportSrv: { type: String },
      path: { type: String },
      __src: { type: String },
    };
  }

  constructor() {
    super();
    this.path = 'DCENN/PZ159'; // for testing
  }

  closeElement() {
    this.dispatchEvent(
      new CustomEvent('close', {
        bubbles: true,
        composed: true,
      }),
    );
  }

  render() {
    // language=html
    return html`${this._renderLoader()} <iframe id="iframeNode" class="station-report" @error="${this._showError}" frameborder="0" src="/services/pdfjs/web/viewer.html?file=${encodeURIComponent(this._srcPath)}"></iframe>
      <ki-icon-btn id="close-btn" icon="ki ki-times" @click="${this.closeElement}"></ki-icon-btn>
      <paper-tooltip for="close-btn">${this.i18n.t('closeView')}</paper-tooltip>`;
  }

  @autoRun('_srcPath')
  _loading() {
    this.__$loaderCount = 1;
    this.requestUpdate();
    setTimeout(()=>{
      this.__$loaderCount -= 1;
      this.requestUpdate();
    },10000)
  }



  _showError(){
    const errorMsg = document.createElement("div");
    errorMsg.innerHTML = "Erreur de chargement de la ressource, veuillez réessayer plus tard";
    this._iframeNode.replaceWith(errorMsg);
  }
}

customElements.define('ki-station-report', KiStationReport);
